var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useRef } from 'react';
import { composeRef } from 'rc-util/lib/ref';
import './TextField.styles.scss';
import { Icon } from '../Icon';
import { InputWrapper } from '../InputWrapper';
var TextField = forwardRef(function TextField(_a, ref) {
    var autoFocus = _a.autoFocus, children = _a.children, className = _a.className, containerRef = _a.containerRef, disabled = _a.disabled, helperText = _a.helperText, helperTextTooltipPlacement = _a.helperTextTooltipPlacement, _b = _a.hideLabel, hideLabel = _b === void 0 ? false : _b, icon = _a.icon, _c = _a.iconPosition, iconPosition = _c === void 0 ? 'none' : _c, label = _a.label, maxLength = _a.maxLength, minLength = _a.minLength, name = _a.name, onBlur = _a.onBlur, onChange = _a.onChange, onFocus = _a.onFocus, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onPaste = _a.onPaste, placeholder = _a.placeholder, rightButton = _a.rightButton, _d = _a.rounded, rounded = _d === void 0 ? false : _d, size = _a.size, supportMessage = _a.supportMessage, _e = _a.tabIndex, tabIndex = _e === void 0 ? 0 : _e, _f = _a.type, type = _f === void 0 ? 'text' : _f, value = _a.value, variant = _a.variant, required = _a.required, props = __rest(_a, ["autoFocus", "children", "className", "containerRef", "disabled", "helperText", "helperTextTooltipPlacement", "hideLabel", "icon", "iconPosition", "label", "maxLength", "minLength", "name", "onBlur", "onChange", "onFocus", "onKeyDown", "onKeyUp", "onPaste", "placeholder", "rightButton", "rounded", "size", "supportMessage", "tabIndex", "type", "value", "variant", "required"]);
    var shouldRenderIcon = false;
    var inputRef = useRef(null);
    var onChangeTextField = function (event) {
        !!onChange && onChange(event);
    };
    if (!!variant && variant !== 'neutral') {
        iconPosition = 'right';
        shouldRenderIcon = true;
        icon = _jsx(_Fragment, {});
    }
    var getContainerClassName = function () {
        var classList = ['hefesto-textfield'];
        if (variant) {
            classList.push("hefesto-textfield--".concat(variant));
        }
        if (type) {
            classList.push("hefesto-textfield--".concat(type));
        }
        if (iconPosition) {
            classList.push("hefesto-textfield--icon-".concat(iconPosition));
        }
        if (disabled) {
            classList.push('hefesto-textfield--disabled');
        }
        if (type === 'search' && rounded) {
            classList.push('hefesto-textfield--rounded');
        }
        return classList.join(' ');
    };
    var containerClassName = getContainerClassName();
    var getInputClassName = function () {
        var classList = ['hefesto-textfield__input'];
        if (className) {
            classList.push(className);
        }
        return classList.join(' ');
    };
    var inputClassName = getInputClassName();
    return (_jsx(InputWrapper, __assign({ disabled: disabled, helperText: helperText, helperTextTooltipPlacement: helperTextTooltipPlacement, hideLabel: hideLabel, label: label, supportMessage: supportMessage, variant: variant, name: name, required: required }, { children: _jsxs("div", __assign({ ref: containerRef, className: containerClassName }, { children: [_jsx("i", __assign({ className: "hefesto-textfield__left-icon" }, { children: !!icon && iconPosition === 'left' && icon })), _jsx("input", __assign({ autoComplete: "off", autoFocus: autoFocus, className: inputClassName, "data-testid": "hefesto-textfield-input", disabled: disabled, id: name, maxLength: maxLength, minLength: minLength, name: name, onBlur: onBlur, onChange: onChangeTextField, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onPaste: onPaste, placeholder: placeholder, ref: composeRef(ref, inputRef), required: true, size: size, tabIndex: tabIndex, type: type, value: value }, props)), children, _jsxs("i", __assign({ className: "hefesto-textfield__right-icon" }, { children: [shouldRenderIcon && (_jsx(Icon, { option: variant === 'success' ? 'CheckCircle2' : 'Alert', variant: variant })), !!icon && iconPosition === 'right' && icon, !!rightButton && rightButton] }))] })) })));
});
export default TextField;
